/**
 * @module cycleTabs
 */

module.exports = function( containerSelector, duration = 15000 ) {
    const containers = document.querySelectorAll( containerSelector );

    if ( containers.length === 0 ) {
        return;
    }

    containers.forEach( ( cycleBlock ) => {
        const isProductTabs = cycleBlock.classList.contains( 'product-tabs' );
        const buttons = isProductTabs
            ? cycleBlock.querySelectorAll( '.nav.nav-tabs .nav-item' )
            : cycleBlock.querySelectorAll( '.nav.nav-tabs button' );

        if ( buttons.length === 0 ) {
            return;
        }

        let currentIndex = 0;
        let interval;

        function activateButton( index ) {
            buttons.forEach( ( btn ) => {
                if ( isProductTabs ) {
                    const navButton = btn.querySelector( 'button' );
                    const activeBar = btn.querySelector( '.border-bottom-active' );

                    if ( navButton ) {
                        navButton.classList.remove( 'active' );
                        navButton.setAttribute( 'aria-selected', 'false' );
                    }

                    if ( activeBar ) {
                        activeBar.classList.remove( 'active' );
                    }
                } else {
                    btn.classList.remove( 'active' );
                    btn.setAttribute( 'aria-selected', 'false' );
                }
            } );

            const button = buttons[ index ];
            if ( ! button ) {
                return;
            }

            if ( isProductTabs ) {
                const navButton = button.querySelector( 'button' );
                const activeBar = button.querySelector( '.border-bottom-active' );

                if ( navButton ) {
                    navButton.classList.add( 'active' );
                    navButton.setAttribute( 'aria-selected', 'true' );

                    const tabTarget = navButton.getAttribute( 'data-bs-target' );
                    const tabContent = document.querySelector( tabTarget );

                    if ( tabContent ) {
                        const allTabs = cycleBlock.querySelectorAll( '.tab-pane' );
                        allTabs.forEach( ( tab ) => tab.classList.remove( 'show', 'active' ) );
                        tabContent.classList.add( 'show', 'active' );
                    }
                }

                if ( activeBar ) {
                    activeBar.classList.add( 'active' );
                }
            } else {
                button.classList.add( 'active' );
                button.setAttribute( 'aria-selected', 'true' );

                const tabTarget = button.getAttribute( 'data-bs-target' );
                const tabContent = document.querySelector( tabTarget );

                if ( tabContent ) {
                    const allTabs = cycleBlock.querySelectorAll( '.tab-pane' );
                    allTabs.forEach( ( tab ) => tab.classList.remove( 'show', 'active' ) );
                    tabContent.classList.add( 'show', 'active' );
                }
            }
        }

        function startCycling( startIndex ) {
            currentIndex = startIndex;
            activateButton( currentIndex );
            clearInterval( interval );

            interval = setInterval( () => {
                currentIndex = ( currentIndex + 1 ) % buttons.length;
                activateButton( currentIndex );
            }, duration );
        }

        startCycling( currentIndex );

        buttons.forEach( ( button, index ) => {
            const clickTarget = isProductTabs ? button.querySelector( 'button' ) : button;
            if ( clickTarget ) {
                clickTarget.addEventListener( 'click', () => {
                    startCycling( index );
                } );
            }
        } );
    } );
};

